import { Component } from "@angular/core";

@Component({
	selector: "app-dialog-actions-container",
	templateUrl: "./dialog-actions-container.component.html",
	styleUrls: ["./dialog-actions-container.component.scss"],
})
export class DialogActionsContainerComponent {}
